/** Canonical company-artifacts surface slug (IntentML company_model tree selection). */
export const COMPANY_ARTIFACT_TREE_SURFACE_SLUG = 'artifact-tree';

export const COMPANY_ARTIFACTS_SELECT_PATH = `/artifacts/${COMPANY_ARTIFACT_TREE_SURFACE_SLUG}`;

export const COMPANY_ARTIFACTS_LEGACY_SELECT_PATH = '/artifacts/select-tree';

const RESERVED_ARTIFACT_PATH_SEGMENTS = new Set([
  COMPANY_ARTIFACT_TREE_SURFACE_SLUG,
  'select-tree',
  'create-root',
]);

export function isCompanyArtifactModelSlug(segment: string | undefined): segment is string {
  if (!segment?.trim()) return false;
  return !RESERVED_ARTIFACT_PATH_SEGMENTS.has(segment.trim());
}

export function companyArtifactsModelPath(modelSlug: string): string {
  return `/artifacts/${encodeURIComponent(modelSlug.trim())}`;
}
